var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	35930: () => (loadStrictVersionCheckFallback("default", "rxjs", [1,7,8,1], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(31340))))))),
	48948: () => (loadStrictVersionCheckFallback("default", "@angular/common", [4,19,1,3], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4621").then(() => (() => (__webpack_require__(60316))))))),
	68930: () => (loadStrictVersionCheckFallback("default", "@angular/core", [4,19,1,3], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs").then(() => (() => (__webpack_require__(37580))))))),
	75858: () => (loadStrictVersionCheckFallback("default", "rxjs/operators", [1,7,8,1], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(23620))))))),
	10386: () => (loadStrictVersionCheckFallback("default", "@angular/core/primitives/signals", [4,19,1,3], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_signals_mjs").then(() => (() => (__webpack_require__(85689))))))),
	31174: () => (loadStrictVersionCheckFallback("default", "@angular/core/primitives/event-dispatch", [4,19,1,3], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_event-dispatch_mjs").then(() => (() => (__webpack_require__(56745))))))),
	96511: () => (loadSingletonFallback("default", "@angular/material/core", () => (__webpack_require__.e("node_modules_angular_material_fesm2022_core_mjs-_90eb2").then(() => (() => (__webpack_require__(74646))))))),
	64515: () => (loadSingletonFallback("default", "@angular/material/form-field", () => (__webpack_require__.e("node_modules_angular_material_fesm2022_form-field_mjs-_1aed2").then(() => (() => (__webpack_require__(24950))))))),
	38729: () => (loadSingletonFallback("default", "@angular/material/button", () => (__webpack_require__.e("node_modules_angular_material_fesm2022_button_mjs-_52ba2").then(() => (() => (__webpack_require__(84175))))))),
	38765: () => (loadSingletonFallback("default", "@angular/material/input", () => (__webpack_require__.e("node_modules_angular_material_fesm2022_input_mjs-_34bc2").then(() => (() => (__webpack_require__(95541))))))),
	2361: () => (loadStrictVersionCheckFallback("default", "@angular/platform-browser", [4,19,1,3], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1").then(() => (() => (__webpack_require__(80436))))))),
	19882: () => (loadStrictVersionCheckFallback("default", "@angular/common/http", [4,19,1,3], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9341").then(() => (() => (__webpack_require__(46443))))))),
	66117: () => (loadSingletonFallback("default", "@angular/material/divider", () => (__webpack_require__.e("node_modules_angular_material_fesm2022_divider_mjs-_593e2").then(() => (() => (__webpack_require__(14102))))))),
	20303: () => (loadSingletonFallback("default", "@angular/material/icon", () => (__webpack_require__.e("node_modules_angular_material_fesm2022_icon_mjs-_bb192").then(() => (() => (__webpack_require__(93840))))))),
	32478: () => (loadStrictVersionCheckFallback("default", "@angular/core/rxjs-interop", [4,19,1,3], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f1").then(() => (() => (__webpack_require__(49074)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"node_modules_angular_common_fesm2022_http_mjs-_f9340": [
		35930,
		48948,
		68930,
		75858
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4620": [
		35930,
		68930
	],
	"node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f0": [
		35930,
		68930,
		75858
	],
	"node_modules_angular_core_fesm2022_core_mjs": [
		10386,
		35930,
		31174,
		75858
	],
	"node_modules_angular_material_fesm2022_autocomplete_mjs-_d4db1": [
		68930,
		96511,
		35930,
		75858,
		48948,
		64515
	],
	"node_modules_angular_material_fesm2022_badge_mjs-_64461": [
		68930,
		96511,
		48948,
		35930,
		75858
	],
	"node_modules_angular_material_fesm2022_bottom-sheet_mjs-_42241": [
		48948,
		68930,
		35930,
		75858,
		96511
	],
	"node_modules_angular_material_fesm2022_button_mjs-_52ba1": [
		35930,
		48948,
		68930,
		75858,
		96511
	],
	"node_modules_angular_material_fesm2022_card_mjs-_17bd1": [
		68930,
		96511
	],
	"node_modules_angular_material_fesm2022_checkbox_mjs-_fc521": [
		48948,
		68930,
		35930,
		75858,
		96511
	],
	"node_modules_angular_material_fesm2022_chips_mjs-_a4071": [
		68930,
		48948,
		35930,
		75858,
		96511,
		64515
	],
	"node_modules_angular_material_fesm2022_core_mjs-_90eb1": [
		35930,
		48948,
		68930,
		75858
	],
	"node_modules_angular_material_fesm2022_datepicker_mjs-_f7481": [
		68930,
		48948,
		35930,
		75858,
		38729,
		96511,
		64515,
		38765
	],
	"node_modules_angular_material_fesm2022_dialog_mjs-_b8751": [
		68930,
		35930,
		75858,
		48948,
		96511
	],
	"node_modules_angular_material_fesm2022_divider_mjs-_593e1": [
		68930,
		96511
	],
	"node_modules_angular_material_fesm2022_expansion_mjs-_0cfc1": [
		68930,
		48948,
		35930,
		75858,
		96511
	],
	"node_modules_angular_material_fesm2022_form-field_mjs-_1aed1": [
		35930,
		48948,
		68930,
		75858,
		96511
	],
	"node_modules_angular_material_fesm2022_grid-list_mjs-_cd021": [
		68930,
		96511,
		48948
	],
	"node_modules_angular_material_fesm2022_icon_mjs-_bb191": [
		2361,
		19882,
		35930,
		48948,
		68930,
		75858,
		96511
	],
	"node_modules_angular_material_fesm2022_input_mjs-_34bc1": [
		35930,
		48948,
		64515,
		68930,
		75858,
		96511
	],
	"node_modules_angular_material_fesm2022_list_mjs-_3eb01": [
		68930,
		48948,
		96511,
		35930,
		75858,
		66117
	],
	"node_modules_angular_material_fesm2022_menu_mjs-_fb4a1": [
		68930,
		48948,
		35930,
		75858,
		96511
	],
	"node_modules_angular_material_fesm2022_progress-bar_mjs-_14ed1": [
		68930,
		48948,
		96511
	],
	"node_modules_angular_material_fesm2022_progress-spinner_mjs-_15ea1": [
		68930,
		48948,
		96511
	],
	"node_modules_angular_material_fesm2022_radio_mjs-_996c1": [
		48948,
		68930,
		35930,
		75858,
		96511
	],
	"node_modules_angular_material_fesm2022_select_mjs-_b9181": [
		68930,
		35930,
		75858,
		48948,
		96511,
		64515
	],
	"node_modules_angular_material_fesm2022_sidenav_mjs-_ad751": [
		68930,
		35930,
		75858,
		48948,
		96511
	],
	"node_modules_angular_material_fesm2022_slide-toggle_mjs-_025b1": [
		68930,
		48948,
		35930,
		75858,
		96511
	],
	"node_modules_angular_material_fesm2022_snack-bar_mjs-_72181": [
		68930,
		38729,
		35930,
		48948,
		75858,
		96511
	],
	"node_modules_angular_material_fesm2022_stepper_mjs-_627a1": [
		68930,
		48948,
		35930,
		75858,
		96511,
		20303
	],
	"node_modules_angular_material_fesm2022_table_mjs-_2d3d1": [
		68930,
		48948,
		35930,
		75858,
		96511
	],
	"node_modules_angular_material_fesm2022_tabs_mjs-_b9231": [
		68930,
		96511,
		48948,
		35930,
		75858
	],
	"node_modules_angular_material_fesm2022_timepicker_mjs-_76121": [
		68930,
		48948,
		96511,
		35930,
		75858,
		64515,
		38765,
		38729
	],
	"node_modules_angular_material_fesm2022_tooltip_mjs-_e18c1": [
		75858,
		68930,
		48948,
		35930,
		96511
	],
	"node_modules_angular_material_fesm2022_tree_mjs-_57c21": [
		35930,
		68930,
		75858,
		48948,
		96511
	],
	"node_modules_angular_platform-browser_fesm2022_animations_mjs-_06a91": [
		68930,
		2361,
		48948
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f0": [
		19882,
		48948,
		68930
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a221": [
		68930,
		35930,
		48948,
		75858,
		2361
	],
	"node_modules_ngrx_store_fesm2022_ngrx-store_mjs-_da111": [
		68930,
		35930,
		75858,
		32478
	],
	"node_modules_ngx-translate_core_dist_fesm2022_ngx-translate-core_mjs-_63781": [
		68930,
		35930,
		75858
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4621": [
		35930
	],
	"node_modules_angular_material_fesm2022_core_mjs-_90eb2": [
		35930,
		48948,
		75858
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1": [
		19882
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9341": [
		35930,
		75858
	],
	"node_modules_angular_material_fesm2022_icon_mjs-_bb192": [
		2361,
		19882
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}